import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';

const secretKey = process.env.NEXT_PUBLIC_CRYPTO_KEY as string;

export const encrypt = (plainText: string): string => {
  return AES.encrypt(plainText, secretKey).toString();
};

export const decrypt = (cipherText: string): string => {
  const bytes = AES.decrypt(cipherText, secretKey);
  return bytes.toString(Utf8);
};
